import React, { useRef } from "react";
import { useSearchParams } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";

import { Button, Col, Image, Row } from "antd";
import Title from "antd/es/typography/Title";

import MultiburoLogo from "assets/logo.svg";
import { useSendTenantSignature } from "../../../hooks/useTenantSignature";
import { toast } from "../../../utils/toast";

const Signature = () => {
  const signatureRef = useRef<any>();

  const [searchParams] = useSearchParams();

  const sendSignatureMutation = useSendTenantSignature();
  const folderId = searchParams.get("folderId");

  const handleClearSignature = () => {
    signatureRef.current?.clear();
  };

  const handleSaveSignature = () => {
    if (signatureRef.current?.isEmpty()) {
      toast.error("Favor de proporcionar una firma.");
      return;
    }
    if (folderId === null || folderId === "") {
      toast.error("Error obteniendo el folder id.");
      return;
    }

    const loadingToastId = toast.loading("Enviando...");

    const blob = dataURItoBlob(
      signatureRef.current.getTrimmedCanvas().toDataURL("image/png"),
    );

    const formData = new FormData();
    formData.append("signature", blob, "signature.png");
    formData.append("folderId", folderId);

    sendSignatureMutation.mutate(formData, {
      onSuccess: (response: any) => {
        toast.dismiss(loadingToastId);
        window.location.replace(response.message);
      },
      onError: () => {
        toast.dismiss(loadingToastId);
      },
    });
  };

  const dataURItoBlob = (dataURI: string) => {
    const byteString = atob(dataURI.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: "image/png" });
  };

  return (
    <>
      <div
        style={{
          background: "#f2f5f9",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Row justify="center" gutter={[16, 16]}>
          <Col>
            <Image src={MultiburoLogo} width={200} preview={false} />
          </Col>
        </Row>
        <Row style={{ marginTop: 25 }} justify="center" gutter={[16, 16]}>
          <Col span={24} style={{ textAlign: "center" }}>
            <Title level={2}>
              Por favor, firma en el recuadro utilizando tu mouse, dedo u otro
              dispositivo.
            </Title>
            <Title level={4}>
              Al firmar, manifiestas que la información proporcionada es
              auténtica.
            </Title>
          </Col>
        </Row>
        <Row style={{ marginTop: 15 }} justify="center" gutter={[16, 16]}>
          <Col>
            <div
              style={{
                background: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                border: "5px solid #8C8C8C",
              }}
            >
              <SignatureCanvas
                // @ts-ignore
                ref={signatureRef}
                penColor="black"
                canvasProps={{
                  width: 400,
                  height: 200,
                  className: "sigCanvas",
                }}
              />
            </div>
          </Col>
        </Row>
        <Row
          style={{ marginTop: 25, marginBottom: 50 }}
          justify="space-around"
          gutter={[16, 16]}
        >
          <Col span={12}>
            <Button
              disabled={sendSignatureMutation.isPending}
              onClick={handleClearSignature}
            >
              Limpiar
            </Button>
          </Col>
          <Col span={12}>
            <Button
              loading={sendSignatureMutation.isPending}
              type={"primary"}
              onClick={handleSaveSignature}
            >
              {sendSignatureMutation.isPending ? "Enviando..." : "Enviar"}
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Signature;
